// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/investigation/css/list.less
// module id = 186
// module chunks = 0